import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: 'ng-select'
})
export class NgSelectAccessibilityDirective implements OnInit {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    const inputElement = this.el.nativeElement.querySelector('input');
    const labelElement = this.getLabelElement();

    if (inputElement) {
      // Set aria-label attribute if label is found
      if (labelElement) {
        const label = labelElement.textContent?.trim() || '';
        this.renderer.setAttribute(inputElement, 'aria-label', label);
      }

      // Set aria-labelledby attribute
      const ariaLabelledby = inputElement.getAttribute('aria-labelledby');
      if (!ariaLabelledby) {
        const labelId = `${inputElement.id}-label`;
        this.renderer.setAttribute(inputElement, 'aria-labelledby', labelId);
        if (labelElement) {
          this.renderer.setAttribute(labelElement, 'id', labelId);
        }
      }

      // Set title attribute
      const title = inputElement.getAttribute('title') || labelElement?.textContent?.trim() || '';
      if (title) {
        this.renderer.setAttribute(inputElement, 'title', title);
      }

      // Set placeholder attribute
      const placeholder = inputElement.getAttribute('placeholder') || labelElement?.textContent?.trim() || '';
      if (placeholder) {
        // this.renderer.setAttribute(inputElement, 'placeholder', placeholder);
      }

      // Correct the autocomplete attribute
      this.renderer.setAttribute(inputElement, 'autocomplete', 'off');
    }
  }

  private getLabelElement(): HTMLElement | null {
    const id = this.el.nativeElement.id;
    if (id) {
      return document.querySelector(`label[for="${id}"]`);
    }
    return null;
  }
}